import { DeleteOutlined } from '@ant-design/icons'
import type { components } from '@fluencelabs/vodopad-admin-api'
import { Button, type TableColumnsType, Typography } from 'antd'

import { FormattedDate } from '@/components/common/FormattedDate'
import { MONO_STYLE } from '@/components/common/MonoId'
import { StatusTag } from '@/components/common/StatusTag'
import { UserEmailLink } from '@/components/common/UserEmailLink'
import { STORAGE_TERMINAL_STATUSES } from '@/constants/statuses'

type UserStorageDto = components['schemas']['UserStorageDto']

export function storageColumns(
  onTerminate: (record: UserStorageDto) => void,
): TableColumnsType<UserStorageDto> {
  return [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 160,
      ellipsis: true,
      render: (id: string) => (
        <Typography.Text copyable={{ text: id }} style={MONO_STYLE}>
          {id.slice(0, 8)}...
        </Typography.Text>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      render: (name: string) => (
        <Typography.Text
          copyable={{ text: name }}
          ellipsis={{ tooltip: name }}
          style={{ maxWidth: '100%' }}
        >
          {name}
        </Typography.Text>
      ),
    },
    {
      title: 'User',
      dataIndex: 'userId',
      key: 'userId',
      ellipsis: true,
      render: (id: string) => (id ? <UserEmailLink userId={id} /> : '—'),
    },
    {
      title: 'Type',
      dataIndex: 'storageType',
      key: 'storageType',
      width: 80,
    },
    {
      title: 'Volume (GB)',
      dataIndex: 'volumeGb',
      key: 'volumeGb',
      width: 110,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (s: string) => <StatusTag status={s} />,
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 180,
      render: (d: string) => <FormattedDate date={d} fmt="PPp" />,
    },
    {
      title: '',
      key: 'actions',
      width: 50,
      render: (_: unknown, record: UserStorageDto) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          disabled={STORAGE_TERMINAL_STATUSES.has(record.status)}
          onClick={() => onTerminate(record)}
        />
      ),
    },
  ]
}
